import BaseLayer from "./BaseLayer";
import {plotDisagreementsHelper} from "../utils/map_utils";

class StitchPostRound0Disagreementv2 extends BaseLayer {

    id = "stitchPostRound0Disagreementv2";
    label = "After";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPostR0Disagreement, textColor} = this.props;
        plotDisagreementsHelper(stitchPostR0Disagreement.result, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchPostRound0Disagreementv2;
